class upsellproductsection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({"opacity":"1"});

      var swiper = new Swiper(
        ".upsell--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 2.2,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next-upsell",
            prevEl: ".swiper-button-prev-upsell",
          },
          breakpoints: {
            768: {
              slidesPerView: 2.8,
            },
            820: {
              slidesPerView: 3.2,
            },
            1024: {
              slidesPerView: 5,
            },
            1200: {
              slidesPerView: 6,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("upsell-product-section", upsellproductsection);